// services/teacherService.js

import axiosConfig from '../../api/axiosConfig';

const teacherService = {
  // Ders istatistiklerini getir
  async getMonthlyStats(teacherId) {
    try {
      const response = await axiosConfig.get(`/ogretmen/lessons/monthly-stats/${teacherId}`);
      return response.data;
    } catch (error) {
      console.error('Monthly stats error:', error);
      throw error;
    }
  },

  // Ders listesini getir
  async getLessons(teacherId) {
    try {
      const response = await axiosConfig.get(`/ogretmen/lessons/teacher/${teacherId}`);
      return response.data;
    } catch (error) {
      console.error('Get lessons error:', error);
      throw error;
    }
  },

  // Aylık ödeme bilgilerini getir
  async getMonthlyPayments(teacherId) {
    try {
      const response = await axiosConfig.get(`/ogretmen/payments/monthly/${teacherId}`);
      return response.data;
    } catch (error) {
      console.error('Monthly payments error:', error);
      throw error;
    }
  },

  // Avans bilgilerini getir
  async getAdvancePayments(teacherId) {
    try {
      const response = await axiosConfig.get(`/ogretmen/advance/teacher/${teacherId}`);
      return response.data;
    } catch (error) {
      console.error('Advance payments error:', error);
      throw error;
    }
  },

  // Bugünün derslerini getir
  async getTodayLessons(teacherId) {
    try {
      const today = new Date().toISOString().split('T')[0];
      const response = await axiosConfig.get(`/ogretmen/lessons/teacher/${teacherId}?date=${today}`);
      return response.data;
    } catch (error) {
      console.error('Today lessons error:', error);
      throw error;
    }
  },

  // Öğrenci listesini getir
  async getStudents() {
    try {
      const response = await axiosConfig.get('/ogretmen/students');
      return {
        success: true,
        message: response.data.message,
        count: response.data.count,
        data: response.data.ogrenciler
      };
    } catch (error) {
      console.error('Get students error:', error);
      throw error;
    }
  },

  // ÖĞRENCİ DETAY FONKSİYONU - EKSİK OLAN
  async getStudentDetail(studentId) {
    try {
      const response = await axiosConfig.get(`/ogretmen/students/${studentId}`);
      return response.data;
    } catch (error) {
      console.error('Get student detail error:', error);
      throw error;
    }
  },

  // ÖĞRENCİ DERSLERİ FONKSİYONU - EKSİK OLAN
  async getStudentLessons(studentId) {
    try {
      const response = await axiosConfig.get(`/ogretmen/students/${studentId}/lessons`);
      return response.data;
    } catch (error) {
      console.error('Get student lessons error:', error);
      throw error;
    }
  },

  // Profil güncelleme
  async updateProfile(data) {
    try {
      const response = await axiosConfig.put('/ogretmen/profile', data);
      return response.data;
    } catch (error) {
      console.error('Update profile error:', error);
      throw error;
    }
  },

  // Şifre değiştirme
  async changePassword(currentPassword, newPassword) {
    try {
      const response = await axiosConfig.put('/ogretmen/change-password', {
        currentPassword,
        newPassword
      });
      return response.data;
    } catch (error) {
      console.error('Change password error:', error);
      throw error;
    }
  }
};

export default teacherService;